module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAABR0lEQVQoU3WRv0tCURzFz3lqz34OEYHhJoRE4hQFSQ5BjUEIrf4JhX+A0izh6tbQEhVNQUsEWdDQkkUgRFMgRBRUlM8f74Q+fKjZd7mX+/2cc+79XqJP6RabjCLX22LvgXWNGZ/Ju5qliLmAh87+H1g33qyklMAdz1w99S+sDAytDDyLCpAsc74aJGG3BV3OtXN/jB4UALX6UiPui9cv+sNng1mCbrSgnG/5Z6svXD0dfSQUApqBAskn7+pn6A9snQxHaHuLTdBB1Vpt24iaa+/FpsC9c+14PG0Lmd7xCNg219/SXbC1P1GCMO3I2X4jQJXMjdewC3/vTS4a4KUT71Tn3q4rNpR8uWr5WLuBAwEJZ159/p848ifLCVr5qbDt4T0AT6ebK2QrpcGGZlnJBw8FLBH4APBlgzUCFUF+A/BJHAE1JqHwC/TidzqYKzKaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.png
// module id = 3Uj3
// module chunks = 1